import { shopPrefix } from '../../config';
import { http } from '../axios';
import { SubscriptionPeriodType } from '../../../models/Article';
import { AddSingleProductToShoppingCartResponseOut } from '../../store/api';
import { UsageCondition } from '../../../models/Product';

export type AddSingleProductRequest = {
    usageCondition: UsageCondition | null;
    subscriptionPeriodType?: SubscriptionPeriodType;
};

type Params = {
    performChecks: boolean;
};

type Options = {
    productId: string;
    body: AddSingleProductRequest;
    params: Params;
};

const url = `${shopPrefix}/v2/shoppingcart/products/:productId/add`;

export const addSingleProductToCart = ({
    body,
    productId,
    params
}: Options): Promise<AddSingleProductToShoppingCartResponseOut> => {
    return http
        .post<AddSingleProductToShoppingCartResponseOut>(url, body, {
            params,
            pathParams: {
                productId
            }
        })
        .then(response => response.data);
};
